import route from './routes/route';
import {  Dimensions } from 'react-native';

export const App = () => {
  return route
}

export default App;
